import { render, staticRenderFns } from "./reporteIndividualCobranzaNuevo.vue?vue&type=template&id=7576531a"
import script from "./reporteIndividualCobranzaNuevo.vue?vue&type=script&lang=js"
export * from "./reporteIndividualCobranzaNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports